import React, { useEffect, useState } from 'react';
import "../Electrician/Electrician.css"
import { useNavigate } from "react-router-dom";
const Cooler = ({ cart, addToCart }) => {
  const navigate = useNavigate();
  const [openService, setOpenService] = useState(null);
  const services = [
    {
  id: 801,
  title: "Air cooler check-up",
  price: 249,
  subtitle: "Basic inspection and performance check",
  extra_detail_1: "Inspection of fan motor, cooling pads, and water pump",
  extra_detail_2: "Quick cleaning and airflow performance testing",
  image: "https://coolingtechno.in/wp-content/uploads/2026/03/air-cooler-repair-in-hyderabad-cooling-techno.png"
},
{
  id: 802,
  title: "Air cooler service",
  price: 699,
  subtitle: "Complete cleaning and servicing",
  extra_detail_1: "Deep cleaning of cooling pads, tank, and fan blades",
  extra_detail_2: "Motor servicing, pump check, and overall performance optimization",
  image: "https://content.jdmagicbox.com/v2/comp/service_catalogue/window-ac-repair-and-services-9999px240.x240.210402132328.s2d4-83v0skr.jpg"
}
  ];
  return (
    <div className='container-fluid service-electrician'>
      <div id="Electronic">
        <h1>Cooler Technician</h1>
      </div>
      <div className='elect-container'>
        <div className="services-section-elect">
          {services.map((service) => {
            const isAdded = cart.some(
              item => item.id === service.id && item.category === service.category
            );
            return (
              <div key={service.id} className="service-card-elect">

                <div className="service-details-elect">
                  <h3>{service.title}</h3>

                  <div className="price-section-elect">
                    <span className="new-price-elect">₹{service.price}</span>
                  </div>
                  <button
                    className=" btn btn-link view-details-elect"
                    onClick={() =>
                      setOpenService(openService === service.id ? null : service.id)
                    }
                  >
                    View Details
                  </button>
                  {openService === service.id && (
                    <div className="extra-details-elect">
                      <p>✔ {service.extra_detail_1}</p>
                      <p>✔ {service.extra_detail_2}</p>
                    </div>
                  )}

                  <ul>
                    <li>{service.subtitle}</li>
                  </ul>
                </div>

                <div className="service-image-elect">
                  <img src={service.image} alt="" /><br />
                  <button
                    onClick={() => addToCart(service)}
                    className={`btn px-5 mt-2 ${isAdded ? "btn-success" : "btn-warning"
                      }`}
                  >
                    {isAdded ? "Added" : "Add"}
                  </button>
                </div>

              </div>
            );
          })}
        </div>
      </div>
    </div>
  )
}

export default Cooler
